export const TABLE_CONFIG = {
  PAGE_SIZE_OPTIONS: [10, 25, 50, 100],

  /**
   * @type {import('@mui/x-data-grid').GridLocaleText}
   */
  LOCALIZATION: {
    noRowsLabel: 'Nenhum registro',

    columnMenuSortAsc: 'Ordenar ASC',
    columnMenuSortDesc: 'Ordenar DESC',
    columnMenuHideColumn: 'Esconder coluna',
    columnMenuShowColumns: 'Gerenciar colunas',
    columnMenuFilter: 'Filtrar',

    columnHeaderSortIconLabel: 'Ordenar',

    toolbarColumns: 'Colunas',
    toolbarFilters: 'Filtros',
    toolbarDensity: 'Espaçamento',
    toolbarDensityComfortable: 'Confortável',
    toolbarDensityStandard: 'Padrão',
    toolbarDensityCompact: 'Compacto',
    toolbarExport: 'Exportar',
    toolbarExportCsv: 'Baixar CSV',
    toolbarExportPrint: 'Imprimir',

    toolbarFiltersTooltipHide: 'Esconder filtros',
    toolbarFiltersTooltipShow: 'Mostrar filtros',

    filterPanelColumns: 'Colunas',
    filterPanelOperator: 'Operador',
    filterPanelInputLabel: 'Valor',
    filterPanelInputPlaceholder: 'Informe o valor',
    filterPanelDeleteIconLabel: 'Remover',

    filterOperatorContains: 'Contém',
    filterOperatorEquals: 'Igual a',
    filterOperatorStartsWith: 'Começa com',
    filterOperatorEndsWith: 'Termina com',
    filterOperatorIsEmpty: 'Sem valor',
    filterOperatorIsNotEmpty: 'Com valor',
    filterOperatorIsAnyOf: 'Qualquer um de',

    filterValueAny: 'Qualquer',
    filterValueFalse: 'Falso',
    filterValueTrue: 'Verdadeiro',

    checkboxSelectionHeaderName: 'Seleção',

    columnsManagementReset: 'Resetar',
    columnsManagementSearchTitle: 'Pesquisar',
    columnsManagementShowHideAllText: 'Mostrar/Esconder todas',

    noResultsOverlayLabel: 'Nenhum resultado encontrado',
    columnMenuUnsort: 'Não ordenado',
    columnsPanelHideAllButton: 'Esconder todas',
    columnsPanelShowAllButton: 'Exibir todas',

    footerRowSelected: (count) =>
      `${count.toLocaleString()} linha(s) selecionada(s)`,

    MuiTablePagination: {
      labelRowsPerPage: 'Linhas por página',
      labelDisplayedRows: ({ count, from, to }) => `${from}-${to} de ${count}`,
    },
  },
}
